export const BACKEND_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const SEO_SITE_NAME = "Deutsche Bewachung & Sicherheit";
export const SEO_DEFAULT_TITLE =
  "Deutsche Bewachung & Sicherheit – Sicherheitsdienst Hannover & Niedersachsen";
export const SEO_DEFAULT_DESC =
  "Professioneller Sicherheitsdienst in Hannover, Bremen, Hamburg, Braunschweig & Wolfsburg. Objektschutz, Revierdienst, Veranstaltungs- und Baustellensicherheit – zuverlässig und einsatzstark.";
export const SEO_BASE_URL = "https://deutschebunds.de";
